var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-wrapper',[_c('edit-office-form',{attrs:{"office-type":"stockist_center","disabled-fields":['code'],"office-id":_vm.$route.params.id},on:{"success":function($event){return _vm.$router.push({ name: 'master.stockist-center' })}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }